export default "__VITE_ASSET__DXV8$pLM__"